var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c("v-flex", { attrs: { xs12: "" } }, [
            _c("h4", [_vm._v(_vm._s(_vm.title))])
          ]),
          _vm._v(" "),
          _c("v-flex", { attrs: { xs12: "" } }, [
            _vm.error
              ? _c("div", { staticClass: "red--text" }, [
                  _vm._v("Please select " + _vm._s(_vm.title))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm._l(_vm.options, function(option, index) {
            return _c(
              "v-flex",
              {
                key: index,
                attrs: { xs4: "" },
                on: {
                  click: function($event) {
                    return _vm.selectOption(option)
                  }
                }
              },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "tile",
                    attrs: { flat: _vm.selectedOption != option }
                  },
                  [_vm._v("\n        " + _vm._s(option) + "\n      ")]
                )
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("v-divider")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42c7c13a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42c7c13a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/CustomizationSelector.vue
// module id = null
// module chunks = 